// extracted by mini-css-extract-plugin
export default {"btn":"checkboxComponent_btn__RCRVD","checkbox-container":"checkboxComponent_checkbox-container__lx8Yx"};